import BaseStrapiCollection from "../base-strapi-collection/base-strapi-collection";
import qs from "qs";
import api from "../../system/api";

export default class BillingSetting extends BaseStrapiCollection {
    static kind = "singleType";
    static singularName = "billing-setting";
    static pluralName = "billing-settings";
    static displayName = "BillingSetting";

    constructor() {
        super(`${BillingSetting.kind}`, `${BillingSetting.singularName}`, `${BillingSetting.pluralName}`);
    }

    async getAll(query = {}) {
        const queryString = qs.stringify({...query}, {
            encodeValuesOnly: true,
        });

        try {
            await this.waitForWorkspace();
            const response = await api.get(`/billing-setting?${queryString}`, {
                ...this.getHeader(),
                suppressGlobalErrorHandler: true,
            });
            return response.data;
        } catch (error) {
            throw this._normalizeError(error);
        }
    }
}
